import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('apiUrl');
export const EBAY_API_URL = new InjectionToken<string>('ebayApiUrl');
